<template>
  <I18nLink to="/">
    <img :data-test="getCypressId('logo-dark')" :src="`${'/img/dark/logo.svg'}`" alt="Fubex logo" h-44px w-auto hidden dark:block>
    <img :data-test="getCypressId('logo-light')" :src="`${'/img/logo.svg'}`" alt="Fubex logo" h-44px w-auto dark:hidden>
  </I18nLink>
</template>
